import {LOAD_COMPANYPROPERTY_DATA, DELETE_A_COMPANYPROPERTY, SAVE_A_COMPANYPROPERTY, UPDATE_A_COMPANYPROPERTY,CLEAR_A_COMPANYPROPERTY_ERROR_MESSAGE} from './actions';


const initialState = {
  companypropertysArray:[],
    deleteCompanypropertyResp:{},
    errorCMsg:{},
    saveCompanypropertyResp:{},
    updateCompanypropertyResp:{}
};




export default function reducer(state = initialState, action) {
  switch (action.type) {
      case CLEAR_A_COMPANYPROPERTY_ERROR_MESSAGE:
          return Object.assign({}, state, {
              errorCMsg: {}
          });
      case LOAD_COMPANYPROPERTY_DATA:
          return Object.assign({}, state, {
              companypropertysArray: action.companypropertysData
          });
          case DELETE_A_COMPANYPROPERTY:
          return Object.assign({}, state, {
              deleteCompanypropertyResp: action.deleteCompanypropertyResponse,
              errorCMsg: action.errorMsg
          });
      case SAVE_A_COMPANYPROPERTY:
          return Object.assign({}, state, {
              saveCompanypropertyResp: action.saveCompanypropertyResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_COMPANYPROPERTY:
          return Object.assign({}, state, {
              updateCompanypropertyResp: action.saveCompanypropertyResponse,
              errorCMsg: action.errorMsg
          });
    /*case LOAD_FARMS_SUCCESS:
      return {
        ...state,
        //all: [...action.payload.categories],  Farshid Uncommnet this out after you know teh payload from the server.
      };*/
    default:
      return state;
  }
}
